import { axiosInstanceV3 } from '@mais-retorno-front/configs/axios-config';

import { GetStocksListUseCase } from '../../useCases/stocks/get-stocks-list.usecase';
import { makeCatchIssueUseCase } from '../catch-issue.factory';

export const makeGetStocksListUseCase = () => {
  const catchIssue = makeCatchIssueUseCase();

  return new GetStocksListUseCase(axiosInstanceV3, catchIssue);
};
